import {
  CloseButton as MantineCloseButton,
  CloseButtonProps as MantineCloseButtonProps,
} from "@mantine/core";
import { forwardRef, MouseEventHandler } from "react";

type CloseButtonProps = MantineCloseButtonProps & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ children, onClick, ...props }, ref) => {
    return (
      <MantineCloseButton ref={ref} onClick={onClick} data-testid="close-button" {...props}>
        {children}
      </MantineCloseButton>
    );
  },
);
